import { createContext } from "react";

import { ModelsCarouselContextType } from "../types/models-carousel";
import { useSafeContext } from "./use-safe-context";

export const ModelsCarouselContext = createContext<ModelsCarouselContextType | undefined>(undefined);

export const useModelsCarouselContext = (): ModelsCarouselContextType => {
  return useSafeContext(ModelsCarouselContext, 'modelsCarouselContext')
}